import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@cl/core/services';
import { ValidateOtpRequest } from '@cl/shared/models/validate-otp-request.model';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { lastValueFrom } from 'rxjs';

@Component({
    selector: 'cl-totp-setup-modal',
    standalone: false,
    templateUrl: './totp-setup-modal.component.html',
    styleUrl: './totp-setup-modal.component.less',
})
export class TotpSetupModalComponent implements OnInit {
    totpSetupQrCodeBase64: string;

    loading: boolean;

    totpCode: string;

    transitionMode: boolean = false;
    totpIgnoresLeft: number;

    constructor(
        private modalRef: NzModalRef<TotpSetupModalComponent>,
        private authService: AuthService,
        private messageService: NzMessageService,
        private router: Router,
        @Inject(NZ_MODAL_DATA) data: { totpIgnoresLeft: number; transitionMode: boolean },
    ) {
        this.totpIgnoresLeft = data?.totpIgnoresLeft;
        this.transitionMode = data?.transitionMode;
    }

    async ngOnInit(): Promise<void> {
        try {
            this.loading = true;
            this.totpSetupQrCodeBase64 = (await this.authService.getTOTPSetupQrCode()).data;
        } catch (ex) {
            console.error(ex);
            if (ex.error?.errors) {
                ex.error.errors.forEach((error) => {
                    this.messageService.error(error);
                });

                if (!this.transitionMode) {
                    this.modalRef.close(false);
                }
                return;
            }

            this.messageService.error('Kļūda veidojot TOTP iestatīšanas QR kodu');

            if (!this.transitionMode) {
                this.modalRef.close(false);
            }

            return;
        } finally {
            this.loading = false;
        }
    }

    async submitTOTP(): Promise<void> {
        try {
            this.loading = true;
            const validateOtpRequest: ValidateOtpRequest = {
                totpCode: this.totpCode,
            };
            await this.authService.setupTOTP(validateOtpRequest);
            this.messageService.success('TOTP divu faktoru autentifikācija veiksmīgi uzstādīta');

            if (this.transitionMode) {
                // refresh token so that the decoded token is updated with the new TOTP status
                await lastValueFrom(this.authService.callRefreshToken());
            }

            this.modalRef.close(true);
        } catch (ex) {
            console.error(ex);
            if (ex.error?.errors) {
                ex.error.errors.forEach((error) => {
                    this.messageService.error(error);
                });
                if (!this.transitionMode) {
                    this.modalRef.close(false);
                }

                return;
            }

            this.messageService.error('Kļūda uzstādot TOTP divu faktoru autentifikāciju');

            if (!this.transitionMode) {
                this.modalRef.close(false);
            }

            return;
        } finally {
            this.loading = false;
        }
    }

    dismiss(): void {
        if (this.totpIgnoresLeft <= 0) {
            return;
        }

        this.modalRef.close(false);
    }

    logout(): void {
        this.authService.logout();
        this.modalRef.close(false);
        this.router.navigateByUrl('/auth/login');
    }
}
